import axios from '../axios';

export const all = (lang) => {
  return axios.get(`/product-overcategories?lang=${lang}`);
};

export const show = (slug, lang) => {
  return axios.get(`/product-overcategories/${slug}?lang=${lang}`);
};

export const edit = (data) => {
  return axios.post(`/product-overcategories/${data.slug}`, data);
};
